"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AwardOtrDataset = void 0;
const interfaces_1 = require("@build-5/interfaces");
const common_1 = require("./common");
/**
 * Award OTR Dataset
 */
class AwardOtrDataset extends common_1.DatasetClass {
    constructor() {
        super(...arguments);
        /**
         * Create Award via OTR
         *
         * @param params Use {@link OtrRequest} with data based on {@link AuctionBidTangleRequest}
         * @returns
         */
        this.create = (params) => new common_1.OtrRequest(this.otrAddress, Object.assign(Object.assign({}, params), { requestType: interfaces_1.TangleRequestType.AWARD_CREATE }));
        /**
         * Fund award via OTR
         *
         * @param params Use {@link OtrRequest} with data based on {@link AuctionBidTangleRequest}
         * @returns
         */
        this.fund = (params) => new common_1.OtrRequest(this.otrAddress, Object.assign(Object.assign({}, params), { requestType: interfaces_1.TangleRequestType.AWARD_FUND }));
        /**
         * Approve participant on the Award
         *
         * @param params Use {@link OtrRequest} with data based on {@link AuctionBidTangleRequest}
         * @returns
         */
        this.approveParticipant = (params) => new common_1.OtrRequest(this.otrAddress, Object.assign(Object.assign({}, params), { requestType: interfaces_1.TangleRequestType.AWARD_APPROVE_PARTICIPANT }));
    }
}
exports.AwardOtrDataset = AwardOtrDataset;
